import { render, staticRenderFns } from "./officialAccAuth.vue?vue&type=template&id=7ef6b313&scoped=true&"
import script from "./officialAccAuth.vue?vue&type=script&lang=js&"
export * from "./officialAccAuth.vue?vue&type=script&lang=js&"
import style0 from "./officialAccAuth.vue?vue&type=style&index=0&id=7ef6b313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef6b313",
  null
  
)

component.options.__file = "officialAccAuth.vue"
export default component.exports